import styled from 'styled-components';

export const PoDetailsMobileWrapper = styled.div`
.mobile-receiving-select .select2-container.mobile-receiving-select {
    margin: 0px !important;
}

.inputs-item {
    align-self: self-end;
}

.mobile-receiving-select .select2-selection__input-container.css-19bb58m {
    padding: 0px !important;
    margin-top: -11px;
}
header{
display: flex;
flex-direction: column;
padding: 10px;
background-color: ${({ theme }) => theme['primary-color']};
border-radius: 8px;
.title-wrapper {
    display: grid;
    align-items: center;
    grid-template-columns: 2fr 1fr 1fr;
    padding-inline: 7px;
    white-space: nowrap;
    gap: 4px;
    h2 {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    color: ${({ theme }) => theme['aqua_haze']};
    margin: 0;
}
p {
    background: #fff;
    font-size: 10px;
    font-weight: 700;
    line-height: 18px;
    text-align: center;
    padding: 3px 7px;
    border-radius: 4px;
    margin: 0;
    color: ${({ theme }) => theme['primary-color']};
    user-select: none;
}
}
.header-item {
    display: flex;
    align-items: center;
    flex-direction: column;
    p {
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        margin: 0px;
        color: #F8FAFB;
        background: none !important;
        &:not(:first-child){
            font-weight: 600;
        }
    }
}
.content-item-wrapper {
    display: grid;
    grid-template-columns: 1fr 3fr;
    align-items: baseline;
    .content-item{
        &:not(:last-child){
        border-right: 1px solid #E0E0E0;
        width: 90%;
    }
        &:not(:first-child){
       padding-left: 6%;
    }
    }
    p {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 0px;
    color: #F8FAFB;
    &:not(:first-child){
      font-weight: 600;
    }
}
}
}
section{
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  grid-row-gap: 12px;
  height: calc(100vh - 258px);
  overflow: auto;
  padding-bottom: 24px;
}
.bottom-actions {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    left: 0;
    button {
    width: 100%;
    margin: 0px;
}
}
.scan-code-wrapper {
    height: calc(100vh - 290px);
    display: flex;
    justify-content: center;
    align-items: center;
}
.scan-post-drawer-data{
    width: 100%;
    padding: 24px 16px;
    .header {
    display: flex;
    align-items: center;
    grid-gap: 8px;
    border-bottom: 1px solid #ECEFF1;
    padding-bottom: 12px;
    margin-bottom: 24px;
    h2 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
    color: ${({ theme }) => theme['label-color-new']};
}
}
.card-item-wrapper {
    padding: 12px;
    border: 1px solid #ECEFF1;
    border-radius: 4px;
    background-color: #F6FBFB;
 .cards-header {
    display: flex;
    align-items: flex-start;
    grid-gap: 12px;
    img {
    width: 69px;
    max-width: 69px;
    object-fit: contain;
    max-height: 69px;
}
.card-content-wrapper {
    display: flex;
    flex-direction: column;
    grid-row-gap: 1px;
    /* grid-column-gap: 9px; */
    p {
    margin: 0;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: ${({ theme }) => theme['label-color-new']};
}
.card-content-item-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    .card-content-item {
    display: flex;
    grid-gap: 3px;
    margin: 2px 0;
    p {
    font-size: 10px;
    font-weight: 400;
    line-height: 12px;
    text-align: left;
    &:not(:first-child){
        font-weight: 600;
        color:${({ theme }) => theme['primary-color']};
    }
}
}
}
}
}
}
.tabs-wrapper {
    display: grid;
    align-items: center;
    grid-template-columns: 1fr 1fr;
    grid-gap: 5px;
    padding: 12px;
    border: 1px solid #ECEFF1;
    border-radius: 5px;
    background: #fff;
    margin-top: 24px;
    margin-bottom: 16px;
     p{
    font-size: 10px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 0;
    text-align: center;
    border-radius: 4px;
    color: #4E5969;
    background-color: #EFF6F7;
    &.active{
    background: ${({ theme, activeTab }) =>
        activeTab === 'loose' ? theme['primary-color'] : activeTab === 'case' ? theme['primary-color'] : '#EFF6F7'};
    color: ${({ theme, activeTab }) =>
        activeTab === 'loose' ? theme['white-color'] : activeTab === 'case' ? theme['white-color'] : '#EFF6F7'};
    }
}
}
.inputs-container {
    display: flex;
    flex-direction: column;
    grid-gap: 8px;
    &:not(:first-child){
        margin-top: 16px;
    }

    p {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    line-height: 30px;
    text-align: left;
    color: ${({theme}) => theme['primary-color']};
}
.inputs-items {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 15px;
    align-items: end;
    &:not(:first-child){
        align-items: unset;
    }
    input{
        height:32px;
    }
    .inputs-item{
        label {
        color: #6f7684;
        font-size: 12px;
        font-weight: 500;
}

span.ant-calendar-picker{
    input{
    color: #546E7A;
    font-size: 14px;
}
svg {
    color: ${({theme}) => theme['primary-color']};
}
}
}
}
}
}
.footer-po-mobile {
    display: flex;
    justify-content: end;
    align-items: center;
    padding: 8px;
    background: #ffff;
    grid-gap: 12px;
    position: fixed;
    right: 8px;
    bottom: 0;
    width: 100%;
}
.drawer-inner-page-view {
    height: calc(100vh - 240px);
    overflow: auto;
}
.map-btn-wrapper{
    /* margin-top: 10px; */
    padding: 1px 3px;
    font-weight: 700;
    line-height: 18px;
    min-width: 79px;
    min-height: 38px;
    font-size: 9px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    background-color: #fff;
    color: #1565D8;
    margin-left: 10px;
}
.disabled-save-button{
      background: #cccccc;
      color: #666666;
      cursor: not-allowed;
      pointer-events: none;
      margin-left: 10px;
      height: 38px;
      min-width: 79px;
      width: 100%;
      padding: 1px 3px;
      font-weight: 400;
      line-height: 11px;
      font-size: 9px;
      text-align: center;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
    }
@media(max-width: 380px){
    .disabled-save-button,
    .map-btn-wrapper{
        margin-left: 0;
    }
}
`;
export const ModalWrapper = styled.div`
.delete-modal-wrapper{
display:flex;
flex-direction:column;
align-items: center;
justify-content:space-between;
font-size: medium;
img{
    width: 50px;
}
@media (max-width: 430px) {
    p{

        font-size:12px  !important;
    }
    }
}`;
